module.exports = __webpack_public_path__ + "img/Microbiome-Testing-kit.35af3f55.jpg";